import React from "react";
import Link from "next/link";
import { COLLECTIONS } from "../../../utils/niftyData";

export default function Collections() {
  const cols = COLLECTIONS;
  return (
    <section id="collections" className="sec-pad" data-screen-label="Collections">
      <div className="wrap">
        <div className="sec-tag"><span className="idx">[ 04 ]</span> COSMIC TREASURES <span className="rule"></span> <span>DEEP-SKY · ON-CHAIN</span></div>
        <h2 className="h-md col-title" data-reveal>Curated celestial collections — each body carries its real catalog designation.</h2>
        <div className="col-grid">
          {cols.map((c, i) => (
            <Link href={"/stars/" + c.slug} legacyBehavior key={i}>
              <a className="col-card panel panel--hover" data-reveal style={{ transitionDelay: (i % 4) * 60 + "ms" }}>
                <div className="col-glyph" style={{ color: c.hue, textShadow: "0 0 18px " + c.hue }}>{c.glyph}</div>
                <div className="col-meta mono"><span>{c.cat}</span><span>ERC-721</span></div>
                <div className="col-name">{c.name}</div>
                <div className="col-desc">{c.desc}</div>
                <div className="col-foot mono"><span className="tnum">{c.count} OBJECTS</span><span className="col-arrow">EXPLORE →</span></div>
              </a>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
